import { NavLink } from 'react-router-dom';
import { IconChart, IconUser } from './icons';

export function TopBar() {
  return (
    <header className="top-bar">
      <span className="top-bar__brand">VitalAI</span>
      <div className="top-bar__actions">
        <NavLink
          to="/tendencias"
          className={({ isActive }) => `top-bar__icon-button${isActive ? ' top-bar__icon-button--active' : ''}`}
          aria-label="Tendencias"
        >
          <IconChart size={20} />
        </NavLink>
        <NavLink
          to="/perfil"
          className={({ isActive }) => `top-bar__icon-button${isActive ? ' top-bar__icon-button--active' : ''}`}
          aria-label="Perfil"
        >
          <IconUser size={20} />
        </NavLink>
      </div>
    </header>
  );
}
